import { Component } from 'react';

import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import styled from 'styled-components';
import { get, map } from 'lodash';

import {
  getDataFilters,
  updateFormNegoce,
  getDataSynthesisKpi,
  getDataSynthesisSalesByCountry,
  getDataSynthesisSalesByWine
} from '../../../actions/negoce';
import { formatDataOptions, formatDataCheckOptions } from '../helper';

import Negoce from '../index';
import NegoceFilters from '../components/NegoceFilter';
import KeyIndicatorsCardContainer from '../components/KeyIndicatorsCard';
import ExportButton from '../../../components/Export/Button';
import Card from '../../../components/Card';
import Spinner from '../../../components/Spinner';
import CardHeader from '../../../components/CardHeader';
import BarGraph from '../../../components/Charts/BarGraph';
import { useUserMe } from '../../../apiTyped/hooks/users.query';

class Synthesis extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  async componentDidMount() {
    await this.formatDataFilters();
    this.findSynthesis();
  }

  async formatDataFilters() {
    await this.props.getDataFilters();
    [
      {
        type: 'currentWine',
        data: this.props.wines || [],
        keys: {
          value: 'wine_id',
          label: 'wine_name'
        }
      },
      {
        type: 'currentCampaign',
        data: this.props.campaigns || [],
        keys: {
          value: 'campaign_id',
          label: 'campaign_name'
        }
      },
      {
        type: 'currentSales',
        data: this.props.salesTypes || [],
        keys: {
          value: 'sale_type_id',
          label: 'sale_type_name'
        }
      }
    ].map((filterParams) => {
      this.setDefaultFilter(filterParams);
    });
  }

  setDefaultFilter({ type, data, keys }) {
    const { updateFormNegoce, form } = this.props;
    const typeExist = get(form, type);
    if (!typeExist) {
      const { value, label } = keys;
      const defaultOptions = data.find(({ is_default }) => is_default === true);
      if (defaultOptions) {
        updateFormNegoce({
          [type]: {
            value: get(defaultOptions, value),
            label: get(defaultOptions, label)
          }
        });
      }
    }
  }

  async handleChangeFilters({ type, data }) {
    this.setState({ loading: true });

    if (get(this.props.form, type)) {
      this.setDefaultFilter({
        type,
        data,
        keys: {
          value: 'sale_type_id',
          label: 'sale_type_name'
        }
      });
    }

    await this.props.updateFormNegoce({
      [type]: data
    });
    return this.findSynthesis();
  }

  async findSynthesis() {
    this.setState({ loading: true });
    const campaignId = get(this.props.currentCampaign, 'value') || -1;
    const saleTypeId = get(this.props.currentSales, 'value') || -1;
    const wineId = get(this.props.currentWine, 'value') || -1;

    await this.props.getDataFilters(campaignId, 'synthese');
    await this.props.getDataSynthesisKpi({ campaignId, saleTypeId, wineId });
    await this.props.getDataSynthesisSalesByCountry({
      campaignId,
      saleTypeId,
      wineId
    });
    await this.props.getDataSynthesisSalesByWine({
      campaignId,
      saleTypeId
    });
    this.setState({ loading: false });
  }

  formatKpi() {
    const { kpi } = this.props;
    const formatedKpi = [
      {
        title: get(kpi, 'quantity_eq_75') || ' ',
        content: I18n.t('negoce.synthesis.kpi.bottlesSold')
      },
      {
        title: get(kpi, 'nb_customers') || ' ',
        content: I18n.t('negoce.synthesis.kpi.customers')
      },
      {
        title: get(kpi, 'quantity_eq_75_n1') || ' ',
        content: I18n.t('negoce.synthesis.kpi.bottlesSoldN-1')
      },
      {
        title: `${get(kpi, 'customer_exclusivity_pct') || ' '}`,
        content: I18n.t('negoce.synthesis.kpi.exclusivityRate')
      },
      {
        title: `${get(kpi, 'quantity_eq_75_over_allocation_pct') || ' '}`,
        content: I18n.t('negoce.synthesis.kpi.resaleRate')
      },
      {
        title: `${get(kpi, 'customer_recurring_pct') || ' '}`,
        content: I18n.t('negoce.synthesis.kpi.loyaltyRate')
      }
    ];
    return formatedKpi;
  }

  formatSalesByCountry() {
    const sales = [];
    const salesNMinusOne = [];
    const countries = get(this.props.salesByCountry, 'countries', []);
    for (const country of countries) {
      for (const [index, sale] of country.sales.entries()) {
        sale.value = {
          value: sale.quantity_eq_75,
          name: country.country_name
        };
        sale.name = country.country_name;
        index === 0 ? salesNMinusOne.push(sale) : sales.push(sale);
      }
    }
    return [sales, salesNMinusOne];
  }

  formatSalesByCountryLabels() {
    const label = get(this.props.currentWine, 'label');
    return [label, `${label} N-1`];
  }

  formatSalesByWine() {
    const sales = [];
    const salesNMinusOne = [];
    const wines = get(this.props.salesByWine, 'wines', []);
    for (const wine of wines) {
      for (const [index, sale] of wine.sales.entries()) {
        sale.value = {
          value: sale.quantity_eq_75,
          name: wine.wine_name
        };
        sale.name = wine.wine_name;
        index === 0 ? salesNMinusOne.push(sale) : sales.push(sale);
      }
    }
    return [salesNMinusOne, sales];
  }

  formatSalesByWineLabels() {
    const labels = map(
      get(this.props.salesByWine, 'wines[0].sales'),
      ({ year }) => year
    );
    return labels;
  }

  renderTooltip(data, labels, format) {
    return (
      <div className="tooltipContainer">
        <div className="tooltipRow">
          <p className="tooltipLabel">{get(labels, '[0]')}:</p>
          <p className="tooltipValue">
            {get(data, '[0].value.value')}
            {format}
          </p>
        </div>
        <div className="tooltipRow">
          <p className="tooltipLabel">{get(labels, '[1]')}:</p>
          <p className="tooltipValue">
            {get(data, '[1].value.value')}
            {format}
          </p>
        </div>
      </div>
    );
  }

  handleTypeLegend() {
    const currentSales = this.props.currentSales;
    const type = get(currentSales, 'value');
    switch (type) {
      case 1:
        return I18n.t('negoce.synthesis.kpi.primors');
      case 2:
        return I18n.t('negoce.synthesis.kpi.deliveries');
      default:
        break;
    }
  }

  render() {
    const campaignsData = this.props.campaigns || [];
    const salesTypesData = this.props.salesTypes || [];
    const winesData = this.props.wines || [];
    const currentSales = this.props.currentSales;
    const campaignId = get(this.props.currentCampaign, 'value');
    const currentWine = this.props.currentWine;
    const availablePresentations = this.props.availablePresentations || [];
    const userLang = get(this.props, 'userLang');

    const optionsCampaign = formatDataOptions(campaignsData, {
      value: 'campaign_id',
      label: 'campaign_name'
    });
    const optionsSales = formatDataCheckOptions(salesTypesData, {
      value: 'sale_type_id',
      label: 'sale_type_name',
      is_default: 'is_default',
      selected_option: get(currentSales, 'value')
    });
    const optionsWine = formatDataOptions(winesData, {
      value: 'wine_id',
      label: 'wine_name'
    });

    const kpiData = this.formatKpi() || [];
    const salesByCountry = this.formatSalesByCountry() || [];
    const salesByCountryLabels = this.formatSalesByCountryLabels() || [];

    const salesByWine = this.formatSalesByWine() || [];
    const saleByWineLabels = this.formatSalesByWineLabels() || [];

    const type = this.handleTypeLegend();

    const defaultCampain = optionsCampaign[0];
    const defaultCampainId = defaultCampain?.value;

    return (
      <Negoce>
        <NegoceContainer>
          <Card>
            <div className="negoceRowContainer">
              <NegoceFilters
                wineFilter={{
                  selectedOption: this.props.currentWine,
                  options: optionsWine,
                  onChange: (value) => {
                    this.handleChangeFilters({
                      type: 'currentWine',
                      data: value
                    });
                  },
                  label: I18n.t('negoce.filters.wines'),
                  placeholder: I18n.t('negoce.filters.winesPlaceholder')
                }}
                campaignFilter={{
                  selectedOption: this.props.currentCampaign || defaultCampain,
                  options: optionsCampaign,
                  onChange: (value) => {
                    this.handleChangeFilters({
                      type: 'currentCampaign',
                      data: value
                    });
                  },
                  label: I18n.t('negoce.filters.date'),
                  placeholder: I18n.t('negoce.filters.datePlaceholder')
                }}
                salesFilter={{
                  disabled: false,
                  label: I18n.t('negoce.filters.salesTypes'),
                  returnValue: true,
                  onChange: (value) => {
                    this.handleChangeFilters({
                      type: 'currentSales',
                      data: {
                        label: I18n.t('negoce.filters.salesTypes'),
                        value: value
                      }
                    });
                  },
                  radioButtons: optionsSales
                }}
              />
              <ExportButton
                options={availablePresentations}
                paths={{
                  ppt: `/negociant/campaign/${
                    campaignId || defaultCampainId
                  }/ppt_export`
                }}
                params={{
                  ppt: {
                    document_type: 'synthese',
                    lang: userLang
                  }
                }}
                newApi
              />
            </div>
          </Card>
          <div className="synthesisContentContainer">
            <KeyIndicatorsCardContainer
              title={
                <Title>
                  <div className="titleContainer">
                    <h1 className="title">
                      {I18n.t('negoce.synthesis.kpi.title')}
                    </h1>
                  </div>

                  {currentSales && currentWine ? (
                    <div className="leftText">
                      <p>
                        {I18n.t('negoce.synthesis.kpi.sales')} {type}{' '}
                        {I18n.t('negoce.synthesis.kpi.of')}{' '}
                        {get(currentWine, 'label')}
                      </p>
                    </div>
                  ) : null}
                </Title>
              }
              indicators={kpiData}
            />
            <Card>
              <CardHeader
                title={I18n.t('negoce.synthesis.salesByWine.title')}
                fontSize="20px"
              />
              <BarGraph
                height={380}
                tooltipOffset={{ x: 160, y: 0 }}
                tooltipOffsetLeft={{ x: 350, y: 0 }}
                renderTooltip={(props) =>
                  this.renderTooltip(props, saleByWineLabels)
                }
                tooltipContent={{ title: 'Tooltip', showName: true }}
                data={salesByWine}
                labels={saleByWineLabels}
                colors={['#e25d34', '#1f2b37']}
              />
            </Card>
            <div className="synthesisWineByCountry">
              <Card>
                <CardHeader
                  title={I18n.t('negoce.synthesis.salesByCountries.title')}
                  fontSize="20px"
                />
                <BarGraph
                  height={380}
                  tooltipOffset={{ x: 135, y: 50 }}
                  tooltipOffsetLeft={{ x: 300, y: 0 }}
                  renderTooltip={(props) =>
                    this.renderTooltip(props, salesByCountryLabels, '%')
                  }
                  yAxisProps={{
                    domain: [0, 100],
                    tickFormatter: (value) => `${value}%`
                  }}
                  tooltipContent={{ title: 'Tooltip', showName: true }}
                  data={salesByCountry}
                  labels={salesByCountryLabels}
                  colors={['#e25d34', '#1f2b37']}
                />
              </Card>
            </div>
          </div>
          <Spinner loading={this.state.loading} />
        </NegoceContainer>
      </Negoce>
    );
  }
}

const Index = (props) => {
  const { user } = useUserMe();
  return <Synthesis {...props} userLang={user.language} />;
};

const mapStateToProps = (state) => {
  return {
    salesTypes: state.negoce.data.sale_types,
    campaigns: state.negoce.data.campaigns,
    wines: state.negoce.data.wines,
    availablePresentations: state.negoce.data.available_presentations,
    currentCampaign: state.negoce.form.currentCampaign,
    currentSales: state.negoce.form.currentSales,
    currentWine: state.negoce.form.currentWine,
    form: state.negoce.form,
    kpi: state.negoce.data.synthesis_kpi,
    salesByCountry: state.negoce.data.synthesis_sales_by_country,
    salesByWine: state.negoce.data.synthesis_sales_by_wines
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDataFilters: (campaignId, presentationType) =>
      dispatch(getDataFilters(campaignId, presentationType)),
    updateFormNegoce: (data) => {
      dispatch(updateFormNegoce(data));
    },
    getDataSynthesisKpi: ({ campaignId, saleTypeId, wineId }) =>
      dispatch(getDataSynthesisKpi({ campaignId, saleTypeId, wineId })),
    getDataSynthesisSalesByCountry: ({ campaignId, saleTypeId, wineId }) =>
      dispatch(
        getDataSynthesisSalesByCountry({ campaignId, saleTypeId, wineId })
      ),
    getDataSynthesisSalesByWine: ({ campaignId, saleTypeId }) =>
      dispatch(getDataSynthesisSalesByWine({ campaignId, saleTypeId }))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);

const NegoceContainer = styled.div`
  .negoceRowContainer {
    display: grid;
    grid-template-columns: 1fr max-content;
    grid-gap: 25px;
  }

  .synthesisContentContainer {
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    margin-bottom: 20px;
  }

  .tooltipContainer {
    padding: 10px;
  }

  .tooltipRow {
    white-space: nowrap;
  }

  .tooltipValue {
    font-weight: bold;
  }

  .tooltipLabel {
    font-size: 16px;
  }

  .synthesisWineByCountry {
    grid-column-start: 1;
    grid-column-end: 3;
  }

  @media (max-width: 1400px) {
    .synthesisContentContainer {
      grid-template-columns: 1fr;
    }

    .synthesisWineByCountry {
      grid-column-start: 1;
      grid-column-end: 1;
    }
  }
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    flex-direction: column;
  }

  .title {
    font-size: 20px;
    font-family: ${(props) => props.theme.fonts.oswald};
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    color: #202529;
    text-transform: uppercase;
  }

  .leftText {
    margin-left: 32px;
    margin-right: 32px;
    opacity: 0.5;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 14px;
    max-width: 66%;
    white-space: normal;
    color: #1e3647;
    p {
      white-space: pre-wrap;
    }
  }
`;
